




































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import OdataResource from '@/modules/api/OdataResource';
import OdataDropdown from '@/modules/form/components/OdataDropdown.vue';
import IFormField from '@/modules/form/interfaces/IFormField.d.ts';
import ISelectLunchRequest from '@/modules/form/interfaces/ISelectLunchRequest.d.ts';

@Component({
    name: 'MealsForm',
    components: {
        OdataDropdown,
    },
})
export default class MealsForm extends Vue {
    @Prop() public keyId!: number;
    @Prop() public keyGuid!: string;
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    private readonly LunchTypesUrl = '/odata/registrations/LunchTypes';
    private readonly SelectLunchRequest = '/odata/registrations/SelectLunchRequests';
    private errored = false;
    private loading = false;
    private selectLunchRequestsResource: OdataResource<ISelectLunchRequest> = new OdataResource<ISelectLunchRequest>(
        this.apiUrl + this.SelectLunchRequest,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );
    private valitationPassed = true;

    private readonly lunchFields = {
        Friday: {
            Name: 'FridayLunchTypeId',
            Label: 'Lunch - Friday / Obiad - Piątek',
            Tooltip: 'Choose lunch / Wybierz obiad',
            Value: '',
            DataSource: "?$filter=IsVisible eq true and contains(Weekday, 'Friday')&",
            IsRequired: false,
            IsEditable: true,
            IsVisible: false,
            FormStateId: 0,
            FieldType: '',
            Order: 0,
            Id: 1,
            ErrorMessage: '',
        },
        Saturday: {
            Name: 'SaturdayLunchTypeId',
            Label: 'Lunch - Saturday / Obiad - Sobota',
            Tooltip: 'Choose lunch / Wybierz obiad',
            Value: '',
            DataSource: "?$filter=IsVisible eq true and contains(Weekday, 'Saturday')&",
            IsRequired: true,
            IsEditable: true,
            IsVisible: true,
            FormStateId: 0,
            FieldType: '',
            Order: 0,
            Id: 2,
            ErrorMessage: '',
        },
        Sunday: {
            Name: 'SundayLunchTypeId',
            Label: 'Lunch - Sunday / Obiad - Niedziela',
            Tooltip: 'Choose lunch / Wybierz obiad',
            Value: '',
            DataSource: "?$filter=IsVisible eq true and contains(Weekday, 'Sunday')&",
            IsRequired: true,
            IsEditable: true,
            IsVisible: true,
            FormStateId: 0,
            FieldType: '',
            Order: 0,
            Id: 3,
            ErrorMessage: '',
        },
    };

    private mounted() {
        this.selectLunchRequestsResource.baseUrl = this.apiUrl + this.SelectLunchRequest;
        this.selectLunchRequestsResource.$on('resourceCreated', this.onSelectLunchRequestCreated);
    }

    private onFormSubmit(): void {
        const formFields: IFormField[] = [this.lunchFields.Friday, this.lunchFields.Saturday, this.lunchFields.Sunday];
        this.valitationPassed = this.validateFormFields(formFields);
        if (!this.valitationPassed) {
            return;
        }

        const eventRegistrationId = this.keyId;
        const eventRegistrationGuid = this.keyGuid;
        const selectLunchRequest: ISelectLunchRequest = {
            EventRegistrationId: eventRegistrationId,
            EventRegistrationGuid: eventRegistrationGuid,
            LunchTypeIds: [
                +this.lunchFields.Friday.Value,
                +this.lunchFields.Saturday.Value,
                +this.lunchFields.Sunday.Value,
            ],
        } as ISelectLunchRequest;
        this.selectLunchRequestsResource.createNewResource(selectLunchRequest);
    }

    private validateFormFields(formFields: IFormField[]): boolean {
        formFields.forEach(field => {
            if (
                field.IsVisible &&
                field.IsRequired &&
                (field.Value === undefined || field.Value === null || field.Value === '')
            ) {
                field.ErrorMessage = field.Name + ' is required.';
            } else {
                field.ErrorMessage = '';
            }
        });

        if (formFields.some(f => f.ErrorMessage !== '')) {
            return false;
        }

        return true;
    }

    private onError(error: object) {
        console.error(error);
        this.errored = true;
    }

    private onResourceLoading() {
        this.loading = true;
    }

    private onResourceLoadingFinished() {
        this.loading = false;
    }

    private onSelectLunchRequestCreated() {
        this.$emit('mealsSelected', { EventRegistrationId: this.keyId, EventRegistrationGuid: this.keyGuid });
    }
}
